/**
 *
 * Conta il numero di possibili parametri all'interno di una chiamata GET scandendo l'oggetto Params
 *
 * @param {{[key: string]: any;} | undefined} params - Parametri in ingresso
 * @returns {number}
 */
export const countNumberOfParams = (
  params:
    | {
        [key: string]: any;
      }
    | undefined
): number => {
  let numberOfParams = 0;
  if (params)
    Object.keys(params).forEach((key) => {
      if (Array.isArray(params[key])) numberOfParams += params[key].length;
      else numberOfParams += 1;
    });

  return numberOfParams;
};
